import React from 'react';
import { Text, Pressable, StyleSheet } from 'react-native';
import { THEME } from '../../constants/styles';
import { OPComponent, PlusView, MinusView, I18n } from '../components';

export default function (props) {
  return (
    <Pressable style={styles.addAnotherButton} onPress={props.onPress}>
      {!!props.remove ? <MinusView /> : <PlusView />}
      <Text style={styles.addAnotherText}>{props.label}</Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  addAnotherButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 20,
  },
  addAnotherText: Object.assign({}, THEME.textRegularLight, {
    flex: 1,
    marginLeft: 15,
  }),
});
